import { type FC, useState } from 'react';
import InputText from '@components/InputText';
import Modal from '@components/Modal';
import { Button } from '@components/ui/button';
import { SAVED_VIEW_NAME_MAX_LENGTH } from '@domain/schemas/saved-view.schema';

interface SaveViewModalProps {
  isLoading: boolean;
  onCancel: () => void;
  onSave: (name: string) => void;
}

export const SaveViewModal: FC<SaveViewModalProps> = ({ isLoading, onCancel, onSave }) => {
  const [name, setName] = useState('');
  const canSave = name.trim().length > 0 && !isLoading;

  return (
    <Modal
      open
      onClose={onCancel}
      data-testid="save-view-modal"
      title="Save this view"
      description="Save these filters as a personal view you can quickly access from the sidebar."
      className="min-w-[600px]"
    >
      <form
        className="pt-2"
        onSubmit={(e) => {
          e.preventDefault();
          if (canSave) onSave(name.trim());
        }}
      >
        <InputText
          labelText="View name"
          autoFocus
          maxLength={SAVED_VIEW_NAME_MAX_LENGTH}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <div className="mt-6 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={!canSave}>
            Save View
          </Button>
        </div>
      </form>
    </Modal>
  );
};
